export default __webpack_public_path__ + "static/media/dining.f98b0f94.png";